import React, { useEffect, useState } from "react";
import Select from "../../../ShareElements/Select/Select";
import EmptyStateVector from "../../../../../../Assets/Images/EmptyState.svg";
import RangeDatePicker from "./RangeDatepicker";
import ESSMobileTableItem from "../../Shared/ESSMobileTableItem";
import { formatDate } from "../../../../../../Helper_functions";
import { useHistory } from "react-router-dom";

const ESSDataTable = (props) => {
  const history = useHistory();
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0]?.label_value;
  };

  const translateJPAType = (Type) => {
    if (Type === "Vacancies") {
      return translateText("jobs");
    } else if (Type === "Projects") {
      return translateText("projects");
    } else {
      return translateText("activities");
    }
  };

  const [SizeOptions] = useState([
    { name: 5, id: 5 },
    { name: 10, id: 10 },
    { name: 15, id: 15 },
    { name: 20, id: 20 },
    { name: 25, id: 25 },
    { name: 50, id: 50 },
  ]);
  const [Pages, setPages] = useState([1, 2, 3]);
  const [SelectedFilter, setSelectedFilter] = useState(
    translateJPAType(props.SelectedJPAType)
  );
  const [PageInfo, setPageInfo] = useState({});
  const [DatepickerIsOpen, setDatepickerIsOpen] = useState(false);
  const [FilterChipIds] = useState([
    "name-filter",
    "location-filter",
    "manager-filter",
    "similarity-filter",
    "applied-filter",
    "status-filter",
    "application-filter",
  ]);
  const [SelectedDate, setSelectedDate] = useState();
  const [FilterIsOpen, setFilterIsOpen] = useState(false);

  useEffect(() => {
    createPagination();
  }, [props]);

  const requestPrevPage = () => {
    let PrevPage;
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        if (document.getElementById(i + "-page-btn").classList.length > 1) {
          if (i === 1) {
            PrevPage = 1;
          } else {
            PrevPage = parseInt(i - 1);
          }
        }
      }
    }
    if (document.getElementById(PrevPage + "-page-btn") !== null) {
      document.getElementById(PrevPage + "-page-btn").click();
    }
  };

  const createPagination = () => {
    let Size = 5;
    if (document.getElementById("pre-selected-row-per-page") !== null) {
      Size = parseInt(
        document.getElementById("pre-selected-row-per-page").innerHTML
      );
    }
    let Count = Math.ceil(props.TotalElements / Size);
    let PagesArray = [];
    for (let i = 0; i < Count; i++) {
      PagesArray.push(i + 1);
    }
    setPages(PagesArray);
    shortenPagination(PagesArray);
  };

  const shortenPagination = (Pages) => {
    if (Pages.length > 0) {
      let LastPage = Pages.reduce((a, b) => {
        return Math.max(a, b);
      });
      let FirstPage = parseInt(Pages[0]);
      let MiddlePage = 3;
      let FirstDotsShown = false;
      let LastDotsShown = true;
      let ActivePage;

      for (let i = 1; i <= Pages.length; i++) {
        if (document.getElementById(i + "-page-btn") !== null) {
          if (
            document
              .getElementById(i + "-page-btn")
              .classList.contains("active-page")
          ) {
            ActivePage = i;
          }
        }
      }
      if (ActivePage < 3) {
        LastDotsShown = true;
      }
      if (ActivePage > 3) {
        FirstDotsShown = true;
        MiddlePage = ActivePage;
        setTimeout(() => {
          updateActiveClass(MiddlePage);
        }, 50);
      }
      if (ActivePage < MiddlePage && ActivePage > 3) {
        FirstDotsShown = true;
        LastDotsShown = true;
      }
      if (parseInt(LastPage - 3) >= ActivePage) {
        LastDotsShown = false;
      }
      if (ActivePage === 3) {
        FirstDotsShown = false;
        MiddlePage = 3;
        setTimeout(() => {
          updateActiveClass(MiddlePage);
        }, 50);
      }
      setPageInfo({
        FirstPage: FirstPage,
        FirstDotsShown: FirstDotsShown,
        MiddlePage: MiddlePage,
        LastDotsShown: LastDotsShown,
        LastPage: LastPage,
        ActivePage: ActivePage,
      });
    } else {
      setPageInfo({
        FirstPage: 1,
        FirstDotsShown: false,
        MiddlePage: 3,
        LastDotsShown: true,
        LastPage: 1,
        ActivePage: 1,
      });
    }
  };
  const updatePaginationlength = (PageNum) => {
    shortenPagination(Pages);
  };

  const requestPageNumber = (PageNumber) => {
    let Size = parseInt(
      document.getElementById("pre-selected-row-per-page").innerHTML
    );
    let NewStart = parseInt((PageNumber - 1) * Size);

    props.FetchData(Size, NewStart, props.SelectedJPAType);

    if (NewStart === 0) {
      document.getElementById("start").innerHTML = 1;
      updateActiveClass(1);
    } else {
      document.getElementById("start").innerHTML = NewStart + 1;
    }
    if (
      parseInt(document.getElementById("end").innerHTML) === props.TotalElements
    ) {
      document.getElementById("next-page").classList.add("page-btn-disabled");
      document
        .getElementById("prev-page")
        .classList.remove("page-btn-disabled");
    } else {
      document.getElementById("end").innerHTML = parseInt(NewStart + Size);
      document
        .getElementById("next-page")
        .classList.remove("page-btn-disabled");
      document
        .getElementById("prev-page")
        .classList.remove("page-btn-disabled");
    }
    if (PageNumber === 1) {
      document
        .getElementById("next-page")
        .classList.remove("page-btn-disabled");
      document.getElementById("prev-page").classList.add("page-btn-disabled");
    }
    updateActiveClass(PageNumber);
    updatePaginationlength(PageNumber);
  };

  const updateActiveClass = (PageNumber) => {
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        document
          .getElementById(i + "-page-btn")
          .classList.remove("active-page");
      }
    }
    if (document.getElementById(PageNumber + "-page-btn")) {
      document
        .getElementById(PageNumber + "-page-btn")
        .classList.add("active-page");
    }
  };

  const requestNextPage = () => {
    let NextPage;
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        if (document.getElementById(i + "-page-btn").classList.length > 1) {
          NextPage = parseInt(i + 1);
        }
      }
    }
    if (document.getElementById(NextPage + "-page-btn") !== null) {
      document.getElementById(NextPage + "-page-btn").click();
    }
  };

  const setSize = () => {
    setTimeout(() => {
      if (document.getElementById("1-page-btn") !== null) {
        document.getElementById("1-page-btn").click();
      }
    }, 300);
  };

  const shortenText = (TextString, Length) => {
    if (TextString) {
      if (TextString.length < Length) {
        return TextString;
      } else {
        let Short = TextString.slice(0, Length - 4) + " ...";
        return (
          <React.Fragment>
            {Short}
            <p className="popup-text">{TextString}</p>
          </React.Fragment>
        );
      }
    }
  };

  const removeSortActiveClassNames = () => {
    props.SortIds.map((Sort) => {
      document.getElementById(Sort).classList.remove("active-pointer");
    });
  };

  // this function only handles the className and the main function that contains the API call is
  // called at the end of this function and is on the parent component.
  const sortTable = (SortType, ChipId) => {
    if (SortType === "name") {
      if (
        document.getElementById("name-up").classList.contains("active-pointer")
      ) {
        removeSortActiveClassNames();
        document.getElementById("name-down").classList.add("active-pointer");
      } else {
        removeSortActiveClassNames();
        document.getElementById("name-up").classList.add("active-pointer");
      }
    } else if (SortType === "location") {
      if (
        document
          .getElementById("location-up")
          .classList.contains("active-pointer")
      ) {
        removeSortActiveClassNames();
        document
          .getElementById("location-down")
          .classList.add("active-pointer");
      } else {
        removeSortActiveClassNames();
        document.getElementById("location-up").classList.add("active-pointer");
      }
    } else if (SortType === "manager") {
      if (
        document
          .getElementById("manager-up")
          .classList.contains("active-pointer")
      ) {
        removeSortActiveClassNames();
        document.getElementById("manager-down").classList.add("active-pointer");
      } else {
        removeSortActiveClassNames();
        document.getElementById("manager-up").classList.add("active-pointer");
      }
    } else if (SortType === "similarity") {
      if (
        document
          .getElementById("similarity-up")
          .classList.contains("active-pointer")
      ) {
        removeSortActiveClassNames();
        document
          .getElementById("similarity-down")
          .classList.add("active-pointer");
      } else {
        removeSortActiveClassNames();
        document
          .getElementById("similarity-up")
          .classList.add("active-pointer");
      }
    } else if (SortType === "applied") {
      if (
        document
          .getElementById("applied-up")
          .classList.contains("active-pointer")
      ) {
        removeSortActiveClassNames();
        document.getElementById("applied-down").classList.add("active-pointer");
      } else {
        removeSortActiveClassNames();
        document.getElementById("applied-up").classList.add("active-pointer");
      }
    } else if (SortType === "status") {
      if (
        document
          .getElementById("status-up")
          .classList.contains("active-pointer")
      ) {
        removeSortActiveClassNames();
        document.getElementById("status-down").classList.add("active-pointer");
      } else {
        removeSortActiveClassNames();
        document.getElementById("status-up").classList.add("active-pointer");
      }
    } else if (SortType === "application") {
      if (
        document
          .getElementById("application-up")
          .classList.contains("active-pointer")
      ) {
        removeSortActiveClassNames();
        document
          .getElementById("application-down")
          .classList.add("active-pointer");
      } else {
        removeSortActiveClassNames();
        document
          .getElementById("application-up")
          .classList.add("active-pointer");
      }
    }

    let Size = 0;
    if (parseInt(document.getElementById("pre-selected-row-per-page"))) {
      Size = parseInt(
        document.getElementById("pre-selected-row-per-page").innerHTML
      );
    }

    if (document.getElementById("1-page-btn") !== null) {
      document.getElementById("1-page-btn").click();
    } else {
      props.FetchData(
        Size,
        0,
        props.SelectedJPAType,
        false,
        null,
        SelectedDate
      );
    }

    if (window.innerWidth <= 450) {
      FilterChipIds.map((Chip) => {
        document.getElementById(Chip).classList.remove("mobile-active-filter");
      });
      document.getElementById(ChipId).classList.add("mobile-active-filter");
    }
  };

  const selectJPACode = (Row) => {
    if (props.SelectedJPAType === "Vacancies") {
      return Row.globalPositionCode;
    } else if (props.SelectedJPAType === "Projects") {
      return Row.globalProjectCode;
    } else if (props.SelectedJPAType === "Activities") {
      return Row.globalActivityCode;
    }
  };

  const resetFilters = () => {
    let Size = 5;
    if (document.getElementById("pre-selected-row-per-page")) {
      Size = parseInt(
        document.getElementById("pre-selected-row-per-page").innerHTML
      );
    }
    props.SetTableIsEmpty(false);
    props.FetchData(Size, 0, props.SelectedJPAType, false, null, null);
    setSelectedDate();
  };

  const nullToZero = (Count) => {
    if (Count === null) {
      return "0";
    } else {
      return Count;
    }
  };

  const displayDatepicker = (DateIsReset, DateRange) => {
    if (DatepickerIsOpen) {
      //   let TitleLike = document.getElementById("search-input").value;

      let Size = 5;
      if (document.getElementById("pre-selected-row-per-page")) {
        Size = parseInt(
          document.getElementById("pre-selected-row-per-page").innerHTML
        );
      }

      if (DateIsReset) {
        props.FetchData(Size, 0, props.SelectedJPAType, false, null);
      } else {
        if (DateRange) {
          props.FetchData(
            Size,
            0,
            props.SelectedJPAType,
            false,
            null,
            DateRange
          );
        } else {
          props.FetchData(Size, 0, props.SelectedJPAType, false, null);
        }
      }
      if (!DateIsReset) {
        setDatepickerIsOpen(false);
      }
      document.getElementById("datepicker-trigger").style.transform = "none";
    } else {
      if (!DateIsReset) {
        setDatepickerIsOpen(true);
      }
      document.getElementById("datepicker-trigger").style.transform =
        "rotate(180deg)";
    }
  };
  const saveSelectedDate = (Start, End) => {
    setSelectedDate({
      start: formatDate(new Date(Start)),
      startTimestamp: Start,
      endTimestamp: End,
      end: formatDate(new Date(End)),
    });
  };

  const formatTheDate = (date) => {
    if (date) return formatDate(new Date(date));
    return date;
  };

  const handleOpenCloseFilter = (Action) => {
    if (Action === "open") {
      setFilterIsOpen(true);
      document
        .getElementById("chat-list-filter-icon")
        .classList.add("icon-rotated");
    } else {
      setFilterIsOpen(false);
      document
        .getElementById("chat-list-filter-icon")
        .classList.remove("icon-rotated");
    }
  };
  const handleSelectFilter = (Id, JPAType) => {
    // props.SaveJPAType(JPAType);
    let RowIds = [
      "table-vacancies-filter",
      "table-projects-filter",
      "table-activities-filter",
    ];
    RowIds.map((Item) => {
      if (document.getElementById(Item) !== null) {
        document.getElementById(Item).classList.remove("selected-chat-filter");
      }
    });
    if (document.getElementById(Id) !== null) {
      document.getElementById(Id).classList.add("selected-chat-filter");
    }
    setSelectedFilter(translateJPAType(JPAType));
    setTimeout(() => {
      if (document.getElementById("filters-outline") !== null) {
        document.getElementById("filters-outline").click();
      }
    }, 100);

    let Size = 5;
    if (document.getElementById("pre-selected-row-per-page")) {
      Size = parseInt(
        document.getElementById("pre-selected-row-per-page").innerHTML
      );
    }

    props.FetchData(Size, 0, JPAType, true);
    setSelectedDate();
  };

  const displaySelectedDate = (Start, End) => {
    if (Start === End) {
      return Start;
    } else {
      return SelectedDate.start + " - " + SelectedDate.end;
    }
  };

  const navigateToJPADetail = (Type, PositionId) => {
    window.localStorage.setItem("JPAItemId", PositionId);
    switch (Type) {
      case "Vacancies":
        history.push("/JobDetails/");
        break;
      case "Projects":
        history.push("/ProjectDetails/");
        break;
      default: //Activities
        history.push("/ActivityDetails/");
    }
  };

  return (
    <React.Fragment>
      <div className="data-table">
        <section className="table-head">
          <h1></h1>
          <div className="dropdown-wrapper">
            {FilterIsOpen ? (
              <div
                className="outline"
                id="filters-outline"
                onClick={() => handleOpenCloseFilter("close")}
              ></div>
            ) : null}
            <div
              className="dropdown-trigger"
              onClick={() => handleOpenCloseFilter("open")}
            >
              <h1 id="filter-text">
                {translateJPAType(props.SelectedJPAType)}
                {" " + translateText("application_status").toLowerCase()}
              </h1>
              <i
                className="feather-chevron-down"
                id="chat-list-filter-icon"
              ></i>
              <React.Fragment>
                <div
                  className={
                    FilterIsOpen ? "chat-list-filter-content" : "hidden"
                  }
                >
                  <section
                    className={
                      props.SelectedJPAType === "Vacancies"
                        ? "chat-list-filter-row selected-chat-filter"
                        : "chat-list-filter-row"
                    }
                    id="table-vacancies-filter"
                    onClick={() =>
                      handleSelectFilter("table-vacancies-filter", "Vacancies")
                    }
                  >
                    {translateText("jobs")}
                    <i className="feather-check"></i>
                  </section>
                  <section
                    className={
                      props.SelectedJPAType === "Projects"
                        ? "chat-list-filter-row selected-chat-filter"
                        : "chat-list-filter-row"
                    }
                    id="table-projects-filter"
                    onClick={() =>
                      handleSelectFilter("table-projects-filter", "Projects")
                    }
                  >
                    {translateText("projects")}
                    <i className="feather-check"></i>
                  </section>
                  <section
                    className={
                      props.SelectedJPAType === "Activities"
                        ? "chat-list-filter-row selected-chat-filter"
                        : "chat-list-filter-row"
                    }
                    id="table-activities-filter"
                    onClick={() =>
                      handleSelectFilter(
                        "table-activities-filter",
                        "Activities"
                      )
                    }
                  >
                    {translateText("activities")}
                    <i className="feather-check"></i>
                  </section>
                </div>
              </React.Fragment>
            </div>
          </div>
          <span
            className={
              props.TableIsEmpty
                ? "export-btn disabled-export"
                : "export-btn ess-export"
            }
            onClick={() => props.ToggleExport()}
          >
            <i className="feather-download"></i>
            <p>
              {window.innerWidth <= 450
                ? translateText("export")
                : translateText("export_data_to_excel")}
            </p>
          </span>
          <section className="datepicker-holder">
            <section className="datepicker-content">
              <i
                className="feather-calendar"
                onClick={() => displayDatepicker()}
              ></i>
              {SelectedDate === undefined ? (
                <p
                  className="displayed-date"
                  onClick={() => displayDatepicker()}
                >
                  {translateText("date_from_to")}
                </p>
              ) : (
                <p
                  className="displayed-date"
                  id="displayed-date"
                  onClick={() => displayDatepicker()}
                >
                  {displaySelectedDate(SelectedDate.start, SelectedDate.end)}
                </p>
              )}
              <i
                id="datepicker-trigger"
                className="feather-chevron-down"
                onClick={() => displayDatepicker()}
              ></i>
              <div className={DatepickerIsOpen ? "datepicker-shown" : "hidden"}>
                <RangeDatePicker
                  SaveSelectedDate={(Start, End) =>
                    saveSelectedDate(Start, End)
                  }
                  Apply={(DateIsReset, DateRange) =>
                    displayDatepicker(DateIsReset, DateRange)
                  }
                  LangData={props.LangData}
                  Close={() => setDatepickerIsOpen(false)}
                  DatePickerIsOpen={DatepickerIsOpen}
                />
              </div>
            </section>
          </section>
        </section>
        <div className="table-wrapper-tablet">
          <div className="table-filters">
            <section
              id="name-filter"
              className="table-filter column-1 mobile-active-filter"
              onClick={() => sortTable("name", "name-filter")}
            >
              <p className="filter-name">{translateText("title")}</p>
              <span className="filter-pointers">
                <i id="name-up" className="feather-chevron-up"></i>
                <i id="name-down" className="feather-chevron-down"></i>
              </span>
            </section>
            <section
              id="location-filter"
              className="table-filter column-2"
              onClick={() => sortTable("location", "location-filter")}
            >
              <p className="filter-name">{translateText("location")}</p>
              <span className="filter-pointers">
                <i id="location-up" className="feather-chevron-up"></i>
                <i id="location-down" className="feather-chevron-down"></i>
              </span>
            </section>
            <section
              id="manager-filter"
              className="table-filter column-3"
              onClick={() => sortTable("manager", "manager-filter")}
            >
              <p className="filter-name">{translateText("hiring_manager")}</p>
              <span className="filter-pointers">
                <i id="manager-up" className="feather-chevron-up"></i>
                <i id="manager-down" className="feather-chevron-down"></i>
              </span>
            </section>
            <section
              id="similarity-filter"
              className="table-filter column-4"
              onClick={() => sortTable("similarity", "similarity-filter")}
            >
              <p className="filter-name">
                {shortenText(translateText("match"), 13)}
              </p>
              <span className="filter-pointers">
                <i
                  id="similarity-up"
                  className="feather-chevron-up active-pointer"
                ></i>
                <i id="similarity-down" className="feather-chevron-down"></i>
              </span>
            </section>
            <section
              id="applied-filter"
              className="table-filter column-4"
              onClick={() => sortTable("applied", "applied-filter")}
            >
              <p className="filter-name">
                {shortenText(translateText("date"), 12)}
              </p>
              <span className="filter-pointers">
                <i id="applied-up" className="feather-chevron-up"></i>
                <i id="applied-down" className="feather-chevron-down"></i>
              </span>
            </section>
            <section
              id="status-filter"
              className="table-filter column-4 column-iconed-last"
              onClick={() => sortTable("status", "status-filter")}
            >
              <p className="filter-name">{translateText("status")}</p>
              <span className="filter-pointers">
                <i id="status-up" className="feather-chevron-up"></i>
                <i id="status-down" className="feather-chevron-down"></i>
              </span>
            </section>
            <section
              id="application-filter"
              className="table-filter column-7"
              onClick={() => sortTable("application", "application-filter")}
            >
              <p className="filter-name">
                {shortenText(translateText("others_applied"), 14)}
              </p>
              <span className="filter-pointers">
                <i id="application-up" className="feather-chevron-up"></i>
                <i id="application-down" className="feather-chevron-down"></i>
              </span>
            </section>
          </div>
          {props.TableIsEmpty ? (
            <div className="empty-state">
              <img alt="" src={EmptyStateVector} />
              <p>{translateText("no_match_filters_text")}</p>
              <button onClick={() => resetFilters()}>
                {translateText("reset_filters")}
              </button>
            </div>
          ) : (
            <main className="table-content">
              {props.Data.length === 0 ? null : (
                <React.Fragment>
                  {props.Data.map((Row, i) => (
                    <>
                      <div className="table-row is-desktop" key={i}>
                        <section className="table-filter column-1">
                          <span className="info-grid">
                            <p className="bg-text">
                              {/* <span
                                onClick={() =>
                                  navigateToJPADetail(
                                    props.SelectedJPAType,
                                    Row.id
                                  )
                                }
                              > */}
                              {shortenText(Row.title, 20)}
                              {/* </span> */}
                            </p>
                            <p className="sm-text">
                              {"(" + selectJPACode(Row) + ")"}
                            </p>
                          </span>
                        </section>
                        <section className="table-text column-2">
                          {shortenText(Row.workCity, 20)}
                        </section>
                        <section className="table-text column-3">
                          {Row.hiringManager
                            ? shortenText(Row.hiringManager, 20)
                            : translateText("n_a")}
                        </section>
                        <section
                          className="table-text column-4"
                          id="similarity-filter-row"
                        >
                          {parseInt(nullToZero(Row.similarity) * 100) + "%"}
                        </section>
                        <section className="table-text column-4 p-0">
                          {formatTheDate(Row.applicationDate)}
                        </section>
                        <section className="table-text column-4 column-iconed-last">
                          {Row.currentStage
                            ? Row.currentStage
                            : translateText("n_a")}
                        </section>
                        <section className="table-text column-7">
                          {nullToZero(Row.otherApplied)}
                        </section>
                      </div>
                      <ESSMobileTableItem
                        RowItem={Row}
                        LangData={props.LangData}
                        SelectedJPAType={props.SelectedJPAType}
                      />
                    </>
                  ))}
                  <div className="info-footer" id="info-footer">
                    <div className="pagenumber-summary">
                      {translateText("showing")}
                      <p id="start">1</p>
                      {translateText("to")}
                      <p id="end">5</p>
                      {translateText("of")}
                      {" " + props.TotalElements + " "}
                      {translateText("items")}.
                    </div>
                    <section className="pagination-holder">
                      <button
                        onClick={() => requestPrevPage()}
                        id="prev-page"
                        className="page-btn page-btn-disabled"
                      >
                        <i className="feather-chevron-left"></i>
                      </button>
                      <React.Fragment>
                        {Pages.length < 6 ? (
                          <React.Fragment>
                            {Pages.map((Page) => (
                              <React.Fragment>
                                {Page === 1 ? (
                                  <button
                                    key={Page}
                                    onClick={() => requestPageNumber(Page)}
                                    className="page-btn active-page"
                                    id={Page + "-page-btn"}
                                  >
                                    {Page}
                                  </button>
                                ) : (
                                  <button
                                    key={Page}
                                    onClick={() => requestPageNumber(Page)}
                                    className="page-btn"
                                    id={Page + "-page-btn"}
                                  >
                                    {Page}
                                  </button>
                                )}
                              </React.Fragment>
                            ))}
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <button
                              onClick={() => requestPageNumber(1)}
                              className="page-btn active-page"
                              id={1 + "-page-btn"}
                            >
                              {1}
                            </button>
                            {PageInfo.FirstDotsShown ? <p>...</p> : null}
                            <button
                              onClick={() =>
                                requestPageNumber(
                                  parseInt(PageInfo.MiddlePage - 1)
                                )
                              }
                              className="page-btn"
                              id={
                                parseInt(PageInfo.MiddlePage - 1) + "-page-btn"
                              }
                            >
                              {parseInt(PageInfo.MiddlePage - 1)}
                            </button>
                            {PageInfo.MiddlePage ===
                            PageInfo.LastPage ? null : (
                              <button
                                onClick={() =>
                                  requestPageNumber(PageInfo.MiddlePage)
                                }
                                className="page-btn"
                                id={PageInfo.MiddlePage + "-page-btn"}
                              >
                                {PageInfo.MiddlePage}
                              </button>
                            )}
                            {parseInt(PageInfo.MiddlePage + 1) >=
                            PageInfo.LastPage ? null : (
                              <button
                                onClick={() =>
                                  requestPageNumber(
                                    parseInt(PageInfo.MiddlePage + 1)
                                  )
                                }
                                className="page-btn "
                                id={
                                  parseInt(PageInfo.MiddlePage + 1) +
                                  "-page-btn"
                                }
                              >
                                {parseInt(PageInfo.MiddlePage + 1)}
                              </button>
                            )}
                            {!PageInfo.LastDotsShown ? <p>...</p> : null}
                            <button
                              onClick={() =>
                                requestPageNumber(PageInfo.LastPage)
                              }
                              className="page-btn"
                              id={PageInfo.LastPage + "-page-btn"}
                            >
                              {PageInfo.LastPage}
                            </button>
                          </React.Fragment>
                        )}
                      </React.Fragment>
                      <button
                        onClick={() => requestNextPage()}
                        id="next-page"
                        className="page-btn"
                      >
                        <i className="feather-chevron-right"></i>
                      </button>
                    </section>
                    <div className="row-count-select">
                      <p className="row-info">
                        {translateText("rows_per_page")}
                      </p>
                      <Select
                        Initial={"5"}
                        Options={SizeOptions}
                        IsWithId
                        PreSelectedId="5"
                        Id={"row-per-page"}
                        ChangeHandler={() =>
                          setTimeout(() => {
                            setSize();
                          }, 100)
                        }
                        ValidationError=""
                      />
                    </div>
                  </div>
                </React.Fragment>
              )}
            </main>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default ESSDataTable;
